export default "__VITE_ASSET__DtMrXWvw__"